import { createContext, useContext, type ReactNode } from 'react';
import type { Item } from '../domain/models';

/** What a host adds to the app's frame without the app knowing about it: the public demo's guide in
 * the sidebar, its notice above the page on phones, and its floating layer. Empty in the real app. */
export interface ShellExtras {
  /** In the sidebar, between the navigation and the signed-in person (wide screens). */
  sidebar?: ReactNode;
  /** Above the page, in its flow. */
  top?: ReactNode;
  /** After everything else, for fixed layers (dialogs, pills, notices). */
  overlay?: ReactNode;
  /** Words to start "request changes" with, for an item (the demo suggests one; people may change it). */
  suggestChange?: (item: Item) => string | undefined;
}

const ShellExtrasContext = createContext<ShellExtras>({});

export const ShellExtrasProvider = ShellExtrasContext.Provider;

export const useShellExtras = () => useContext(ShellExtrasContext);
